import { useState } from "react";

const useConfirm = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [config, setConfig] = useState({});
  const [loading, setLoading] = useState(false);

  const openConfirm = (options) => {
    setConfig(options);
    setIsOpen(true);
  };

  const closeConfirm = () => {
    if (!loading) {
      setIsOpen(false);
      setConfig({});
    }
  };

  const handleConfirm = async () => {
    try {
      setLoading(true);
      await config.onConfirm?.();
      closeConfirm();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return { isOpen, config, loading, openConfirm, closeConfirm, handleConfirm, };
};

export default useConfirm;